import { ImageList, ImageListItem, Stack, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { BasicCard } from "../molecules";

export const BundleSection = ({ bundles, style }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!bundles?.length) return null;

  return (
    <Stack spacing="24px" style={style}>
      <ImageList gap={16} sx={{ gridAutoFlow: "column", margin: 0 }}>
        {bundles.map((bundle) => (
          <ImageListItem key={bundle.id}>
            <BasicCard
              title={bundle.name}
              imageSrc={bundle.cover_image}
              href={`/bundle/${bundle.slug}`}
              alignItems="start"
              titleStyle={{ color: "white", fontSize: isMobile ? "20px" : "32px" }}
              hideArrow
              style={{ width: isMobile ? "80vw" : "540px", height: "180px" }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Stack>
  );
};
